import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

export interface IntrestPageAnswer {
  defaultValue: string;
  defaultLabel: string;
}
@Component({
  selector: "app-checkboxoption",
  templateUrl: "./checkboxoption.component.html",
  styleUrls: ["./checkboxoption.component.scss"],
})
export class CheckboxoptionComponent implements OnInit {
  @Input() options: any;
  @Input() pageAnswer: Map<string, IntrestPageAnswer>;
  @Input("Affinityindex") Affinityindex: number;
  @Input("Universityindex") Universityindex: number;
  @Input("index") index: string;

  @Input("name") name: string;
  @Input("placeholder") placeholder: string;
  selectValue: string = "";
  @Output() selectChange: EventEmitter<string> = new EventEmitter<string>();
  constructor() {}

  ngOnInit(): void {
    if (this.pageAnswer) {
      let SelectOption = this.pageAnswer.get(this.index);
      if (SelectOption != undefined) {
        this.selectValue = SelectOption.defaultValue;
      }
    }
  }


   firstLetterUpper(strOption) {
    var str = strOption.toLowerCase().replace(/(^\s*\w|[\.\!\?]\s*\w)/g,function(c){return c.toUpperCase()});
    return str;
  }

  changeAffinityQuestionOption(
    index: number,
    option: number,
    optionSelected: any
  ) {
    this.selectChange.emit(optionSelected);
  }

  ngOnChanges() {
    if (this.pageAnswer) {
      let SelectOption = this.pageAnswer.get(this.index);
      if (SelectOption != undefined) {
        this.selectValue = SelectOption.defaultValue;
      }
    }
  }
}
